(function () {

  function getPriceValue(str) {
    if (!str) return 0;
    return parseFloat(str.replace(/[^0-9.]/g, ''));
  }

  // Create a replacement element that mirrors the original
  function createReplacementElement(originalEl, newText, type) {
    const replacement = document.createElement('span');
    replacement.textContent = newText;
    replacement.setAttribute('data-aiod-replacement', type);
    
    // Copy relevant classes from original (except loop-display-none)
    originalEl.classList.forEach(cls => {
      if (cls !== 'loop-display-none') {
        replacement.classList.add(cls);
      }
    });
    
    return replacement;
  }

  // Hide original and insert replacement after it
  function hideAndReplace(originalEl, newText, type) {
    // Check if we already created a replacement for this element
    const existingReplacement = originalEl.parentNode.querySelector(`[data-aiod-replacement="${type}"]`);
    
    if (existingReplacement) {
      // Update existing replacement text if needed
      if (existingReplacement.textContent !== newText) {
        existingReplacement.textContent = newText;
      }
      return existingReplacement;
    }
    
    // Hide the original element
    originalEl.style.display = 'none';
    originalEl.setAttribute('data-aiod-hidden', 'true');
    
    // Create and insert replacement
    const replacement = createReplacementElement(originalEl, newText, type);
    originalEl.parentNode.insertBefore(replacement, originalEl.nextSibling);
    
    return replacement;
  }

  window.syncLoopPricesFromAIOD = function() {
    if (window.syncLoopRetryInterval) {
      clearInterval(window.syncLoopRetryInterval);
    }
    
    let synced = syncLoopPrices();
    
    if (!synced) {
      let attempts = 0;
      const maxAttempts = 10;
      window.syncLoopRetryInterval = setInterval(() => {
        attempts++;
        synced = syncLoopPrices();
        if (synced || attempts >= maxAttempts) {
          clearInterval(window.syncLoopRetryInterval);
          window.syncLoopRetryInterval = null;
        }
      }, 500);
    }
    
    return synced;
  };

  function syncLoopPrices() {
    const aiodPriceEl = document.querySelector('.aiod-discounted-price');
    if (!aiodPriceEl) return false;

    const aiodPriceText = aiodPriceEl.textContent.trim();
    const aiodPriceValue = getPriceValue(aiodPriceText);

    if (!aiodPriceValue) return false;

    let synced = false;

    // One-time purchase
    const oneTimeContainer = document.querySelector('.loop-widget-purchase-option-onetime');
    if (oneTimeContainer) {
      const priceEl = oneTimeContainer.querySelector('.loop-widget-purchase-option-price:not([data-aiod-hidden])');
      const compareAtEl = oneTimeContainer.querySelector('.loop-widget-purchase-option-compare-at-price:not([data-aiod-hidden])');
      const badgeEl = oneTimeContainer.querySelector('.loop-widget-purchase-option-discount-badge');

      if (priceEl) {
        const currentLoopPriceText = priceEl.textContent.trim();
        const currentLoopPriceValue = getPriceValue(currentLoopPriceText);

        if (currentLoopPriceValue && currentLoopPriceValue !== aiodPriceValue) {
          // Hide original compare-at and create replacement with original price
          if (compareAtEl) {
            const compareReplacement = hideAndReplace(compareAtEl, currentLoopPriceText, 'onetime-compare-at');
            compareReplacement.classList.remove('loop-display-none');
          }

          // Hide original price and create replacement with AIOD price
          hideAndReplace(priceEl, aiodPriceText, 'onetime-price');
          
          synced = true;

          if (badgeEl && currentLoopPriceValue > aiodPriceValue) {
            const diff = currentLoopPriceValue - aiodPriceValue;
            const percentage = Math.round((diff / currentLoopPriceValue) * 100);
            
            if (percentage > 0) {
              badgeEl.textContent = `Save ${percentage}%`;
              badgeEl.classList.remove('loop-display-none');
            }
          }
        }
      }
    }

    // Subscribe / selling plan
    const sellingPlanContainer = document.querySelector('[data-loop-widget-selling-plan-group]');
    if (sellingPlanContainer) {
      const subPriceEl = sellingPlanContainer.querySelector('.loop-widget-purchase-option-price:not([data-aiod-hidden])');
      const subCompareAtEl = sellingPlanContainer.querySelector('.loop-widget-purchase-option-compare-at-price:not([data-aiod-hidden])');
      const subBadgeEl = sellingPlanContainer.querySelector('.loop-widget-purchase-option-discount-badge');

      if (subPriceEl && subCompareAtEl && subBadgeEl) {
        const subPriceValue = getPriceValue(subPriceEl.textContent);
        
        // Hide original compare-at and create replacement with AIOD price
        const subCompareReplacement = hideAndReplace(subCompareAtEl, aiodPriceText, 'subscribe-compare-at');
        subCompareReplacement.classList.remove('loop-display-none');

        if (aiodPriceValue > subPriceValue && subPriceValue > 0) {
          const diff = aiodPriceValue - subPriceValue;
          const percentage = Math.round((diff / aiodPriceValue) * 100);
          
          if (percentage > 0) {
            subBadgeEl.textContent = `Save extra ${percentage}%`;
            subBadgeEl.classList.remove('loop-display-none');
          }
          
          synced = true;
        }
      }
    }

    return synced;
  }

  function setupUrlChangeListener() {
    let lastUrl = location.href;

    // Select one-time purchase option
    function selectOneTimePurchase() {
      const oneTimeRadio = document.querySelector('.loop-widget-purchase-option-onetime input[type="radio"]');
      if (oneTimeRadio && !oneTimeRadio.checked) {
        oneTimeRadio.click();
      }
    }

    // Handle URL changes
    function onUrlChange() {
      const currentUrl = location.href;
      if (currentUrl !== lastUrl) {
        lastUrl = currentUrl;
        // Select one-time purchase when variant changes
        selectOneTimePurchase();
        // Use the retry mechanism since AIOD may need time to update after variant change
        window.syncLoopPricesFromAIOD();
      }
    }

    // Listen for popstate (browser back/forward)
    window.addEventListener('popstate', onUrlChange);

    // Intercept pushState and replaceState (used by Shopify for variant changes)
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function(...args) {
      originalPushState.apply(this, args);
      onUrlChange();
    };

    history.replaceState = function(...args) {
      originalReplaceState.apply(this, args);
      onUrlChange();
    };

    // Initial sync on page load
    window.syncLoopPricesFromAIOD();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupUrlChangeListener);
  } else {
    setupUrlChangeListener();
  }

})();
 